module.exports = __webpack_public_path__ + "media/src/shared_components/images/assign_icon-23a55e0a55c4f095880bd47141f15c56.svg";